"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ArrowUpDown } from "lucide-react";
import { useState } from "react";
type SortKey = "name" | "google" | "yotpo" | "average";
type SortDirection = "asc" | "desc";
interface Roaster {
  id: number;
  name: string;
  logo: string;
  packageImage: string;
  googleRating: number;
  yotpoRating: number;
  averageRating: number;
  flavorProfile: string;
  websiteUrl: string;
}
export default function TopRoastersRatingTable() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [sortKey, setSortKey] = useState<SortKey>("average");
  const [sortDirection, setSortDirection] = useState<SortDirection>("desc");
  const roastersData: Roaster[] = [{
    id: 1,
    name: "Gold Star Coffee",
    logo: "https://bestcoffeecanada.com/wp-content/uploads/2025/11/2024-Logo-2-Lines-Gold-Star-Coffee-Black-Text-Transparent.png",
    packageImage: "https://www.goldstarcoffee.ca/cdn/shop/files/rn-image_picker_lib_temp_b4709b80-d30f-4ba6-901a-623cb9e49bde.png?v=1763700210&width=1080",
    googleRating: 4.9,
    yotpoRating: 4.95,
    averageRating: 4.925,
    flavorProfile: "Award-winning single-origin beans with meticulous roasting profiles",
    websiteUrl: "https://www.goldstarcoffee.ca"
  }, {
    id: 2,
    name: "49th Parallel Coffee Roasters",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/49th_parallel_coffee_roasters_logo.png",
    packageImage: "https://49thcoffee.com/cdn/shop/files/2025-Poppy-Barly_01_1460x1460.png?v=1756881140",
    googleRating: 4.8,
    yotpoRating: 4.75,
    averageRating: 4.775,
    flavorProfile: "Vancouver-based roaster specializing in direct-trade relationships and innovative brewing",
    websiteUrl: "https://www.49thcoffee.com"
  }, {
    id: 3,
    name: "Monogram Coffee",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/monogram_coffee_logo.png",
    packageImage: "https://monogramcoffee.com/cdn/shop/files/warmth-filter_971a74d4-508e-4373-b8a9-929e6293db1c.png?v=1760562609&width=1000",
    googleRating: 4.8,
    yotpoRating: 4.7,
    averageRating: 4.75,
    flavorProfile: "Precision roasting with transparent sourcing and tasting notes",
    websiteUrl: "https://www.monogramcoffee.com"
  }, {
    id: 4,
    name: "Pilot Coffee Roasters",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/pilot_coffee_roasters_logo.png",
    packageImage: "https://pilotcoffeeroasters.com/cdn/shop/files/Product_Badge_Heritage_300g_WB.jpg?v=1740712482&width=700",
    googleRating: 4.7,
    yotpoRating: 4.8,
    averageRating: 4.75,
    flavorProfile: "Urban roastery known for experimental blends and seasonal offerings",
    websiteUrl: "https://www.pilotcoffeeroasters.com"
  }, {
    id: 5,
    name: "Hatch Coffee Roasters",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/hatch_coffee_roasters_logo.png",
    packageImage: "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcQqMVIZD9ifeSeRQiPCw2wSf30N6QJEkS87UDBFNFFCDTQ_b9igH2tEkxuZ7V4wNw5SQHhmvmRv1EfsFVTQuxhc0FTSzyC3oA",
    googleRating: 4.7,
    yotpoRating: 4.75,
    averageRating: 4.725,
    flavorProfile: "Small-batch roaster dedicated to showcasing exceptional single-origin coffees with unique terroir",
    websiteUrl: "https://www.hatchcoffeeroasters.com"
  }, {
    id: 10,
    name: "Green Coffee Traders",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/green_coffee_traders_logo.png",
    packageImage: "https://greencoffeetraders.ca/cdn/shop/products/GCT_-_1JBM_New_bag_1024x1024@2x.jpg?v=1598997086",
    googleRating: 4.7,
    yotpoRating: 4.75,
    averageRating: 4.725,
    flavorProfile: "Premium green coffee importers offering freshly roasted specialty beans with exceptional quality and traceability",
    websiteUrl: "https://www.greencoffeetraders.ca"
  }, {
    id: 6,
    name: "De Mello Coffee",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/de_mello_coffee_logo.png",
    packageImage: "https://i0.wp.com/demellocoffee.com/wp-content/uploads/2025/10/de-mello-coffee-colombia-inza%CC%81-227.png?fit=900%2C900&ssl=1",
    googleRating: 4.7,
    yotpoRating: 4.65,
    averageRating: 4.675,
    flavorProfile: "Portuguese-inspired roastery with rich, full-bodied espresso blends",
    websiteUrl: "https://www.demellocoffee.com"
  }, {
    id: 7,
    name: "Rogue Wave Coffee",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/rogue_wave_coffee_logo.png",
    packageImage: "https://eightouncecoffee.ca/cdn/shop/files/698c904b-ba9b-4c93-bff7-1903cc9b8157.png?v=1754579277&width=1000",
    googleRating: 4.7,
    yotpoRating: 4.65,
    averageRating: 4.675,
    flavorProfile: "Coastal-inspired roaster featuring bright, clean coffee profiles",
    websiteUrl: "https://www.roguewavecoffee.ca"
  }, {
    id: 8,
    name: "Detour Coffee",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/detour_coffee_logo.png",
    packageImage: "https://detourcoffee.com/cdn/shop/files/DT-CoffeeBag_ElDuraznoGuatemala_1080x.png?v=1762969600",
    googleRating: 4.6,
    yotpoRating: 4.7,
    averageRating: 4.65,
    flavorProfile: "Community-focused roastery with rotating seasonal micro-lots",
    websiteUrl: "https://www.detourcoffee.com"
  }, {
    id: 9,
    name: "Phil & Sebastian Coffee Roasters",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/phil_sebastian_coffee_roasters_logo.png",
    packageImage: "https://philsebastian.com/cdn/shop/files/JungleBerryOct-1.webp?v=1759527227&width=1400",
    googleRating: 4.6,
    yotpoRating: 4.6,
    averageRating: 4.6,
    flavorProfile: "Calgary-based roaster offering balanced, approachable specialty beans",
    websiteUrl: "https://www.philsebastian.com"
  }];
  const handleSort = (key: SortKey) => {
    if (sortKey === key) {
      setSortDirection(prev => prev === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortDirection("desc");
    }
  };
  const sortedRoasters = [...roastersData].sort((a, b) => {
    let aVal: number | string = 0;
    let bVal: number | string = 0;
    switch (sortKey) {
      case "name":
        aVal = a.name;
        bVal = b.name;
        break;
      case "google":
        aVal = a.googleRating;
        bVal = b.googleRating;
        break;
      case "yotpo":
        aVal = a.yotpoRating;
        bVal = b.yotpoRating;
        break;
      case "average":
        aVal = a.averageRating;
        bVal = b.averageRating;
        break;
    }
    if (typeof aVal === "string" && typeof bVal === "string") {
      return sortDirection === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    }
    if (typeof aVal === "number" && typeof bVal === "number") {
      return sortDirection === "asc" ? aVal - bVal : bVal - aVal;
    }
    return 0;
  });
  return <section ref={ref} className="w-full bg-light-background py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-foreground-light mb-2">
            Top Coffee Roasters in Canada
          </h2>
          <p className="text-lg text-muted-foreground">
            Discover the finest specialty coffee roasters rated by real customers
          </p>
        </div>

        <div className="glass-effect overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow className="hover:bg-transparent">
                <TableHead className="w-[25%]">
                  <Button onClick={() => handleSort("name")} variant="ghost" className="flex items-center gap-2 font-semibold text-foreground-light hover:text-primary hover:bg-transparent transition-colors duration-[var(--duration-fast)] p-0 h-auto" aria-label="Sort by roaster name">
                    Roaster
                    <ArrowUpDown className={`w-4 h-4 transition-transform duration-[var(--duration-medium)] ${sortKey === "name" && sortDirection === "desc" ? "rotate-180" : ""}`} />
                  </Button>
                </TableHead>
                <TableHead className="w-[12%] text-center">
                  <Button onClick={() => handleSort("google")} variant="ghost" className="flex items-center justify-center gap-2 font-semibold text-foreground-light hover:text-primary hover:bg-transparent transition-colors duration-[var(--duration-fast)] w-full p-0 h-auto" aria-label="Sort by Google rating">
                    Google
                    <ArrowUpDown className={`w-4 h-4 transition-transform duration-[var(--duration-medium)] ${sortKey === "google" && sortDirection === "desc" ? "rotate-180" : ""}`} />
                  </Button>
                </TableHead>
                <TableHead className="w-[12%] text-center">
                  <Button onClick={() => handleSort("yotpo")} variant="ghost" className="flex items-center justify-center gap-2 font-semibold text-foreground-light hover:text-primary hover:bg-transparent transition-colors duration-[var(--duration-fast)] w-full p-0 h-auto" aria-label="Sort by Yotpo rating">
                    Yotpo
                    <ArrowUpDown className={`w-4 h-4 transition-transform duration-[var(--duration-medium)] ${sortKey === "yotpo" && sortDirection === "desc" ? "rotate-180" : ""}`} />
                  </Button>
                </TableHead>
                <TableHead className="w-[12%] text-center">
                  <Button onClick={() => handleSort("average")} variant="ghost" className="flex items-center justify-center gap-2 font-semibold text-foreground-light hover:text-primary hover:bg-transparent transition-colors duration-[var(--duration-fast)] w-full p-0 h-auto" aria-label="Sort by average rating">
                    Average
                    <ArrowUpDown className={`w-4 h-4 transition-transform duration-[var(--duration-medium)] ${sortKey === "average" && sortDirection === "desc" ? "rotate-180" : ""}`} />
                  </Button>
                </TableHead>
                <TableHead className="w-[39%]">What Makes Them Special</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {sortedRoasters.map((roaster, i) => <TableRow key={roaster.id} data-index={i} className={`hover:-translate-y-[3px] hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: isVisible ? `${i * 150}ms` : "0ms"
            }}>
                  <TableCell className="font-medium">
                    <Link to={roaster.websiteUrl} newTab className="text-primary hover:text-primary-hover hover:underline transition-colors duration-[var(--duration-fast)]">
                      {roaster.name}
                    </Link>
                  </TableCell>
                  <TableCell className="text-center">
                    <span className="inline-flex items-center justify-center px-3 py-1 rounded-full bg-primary-light text-primary font-semibold text-sm">
                      {roaster.googleRating.toFixed(1)}
                    </span>
                  </TableCell>
                  <TableCell className="text-center">
                    <span className="inline-flex items-center justify-center px-3 py-1 rounded-full bg-accent-light text-accent font-semibold text-sm">
                      {roaster.yotpoRating.toFixed(2)}
                    </span>
                  </TableCell>
                  <TableCell className="text-center">
                    <span className="inline-flex items-center justify-center px-3 py-1 rounded-full bg-secondary-light text-secondary font-semibold text-sm">
                      {roaster.averageRating.toFixed(3)}
                    </span>
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {roaster.flavorProfile}
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
      </div>
    </section>;
}